import React, { Component, Fragment } from 'react';
import { map } from 'lodash';
import ErrorMessage from './errorMessage';

class HHRoleSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.field.value || ''
    };
  }

  onClick = (field, option) => {
    this.setState({ value: option.value });
    this.props.form.setFieldValue(field.name, option.value);
  }

  computeClasses = (option) => {
    let classes = 'role-selector';
    if (this.state.value === option.value) { classes = [classes, 'selected'].join(' '); }
    return classes;
  };

  render = () => {
    const {
      field,
      form: { touched, errors },
      otherProps = {}
    } = this.props;

    const {
      options
    } = otherProps;

    const hasError = !!(touched[field.name] && errors[field.name]);

    return (
      <Fragment>
        { map(options, (option, index) => (
          <div
            key={index}
            className={this.computeClasses(option)}
            onClick={() => this.onClick(field, option)}
          >
            {option.caption}
          </div>
            ))
            }
        {hasError && (<ErrorMessage error={errors[field.name]} />)}
      </Fragment>
    );
  }
}

export default HHRoleSelector;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhRoleSelector.js